<template>
	<div
		class="fromInfo paddingSize"
		:style="{
			marginTop: data.marginTop + 'px',
			paddingTop: data.paddingTop + 'px',
		}"
	>
		<div class="form_item" ref="fromInfo">
			<div class="form_item_title">
				<img src="../../assets/images/one.png" alt="" />
			</div>
			<div class="form_item_title title_name">
				<span>{{ data.content }}</span>
			</div>

			<div class="form_item_content" v-if="data.content || data.data.length > 0">
				<div class="input_item">
					<div class="input_name">兑换码：</div>
					<div class="input_box">
						<input type="text" v-model="form.redeemCode" />
					</div>
				</div>
				<div class="input_item" v-for="(item, index) in data.data" :key="index">
					<div class="input_name lableName">{{ item.lable }}：</div>
					<div class="input_box">
						<input type="text" v-model="form[item.model]" />
					</div>
				</div>
			</div>

			<div class="form_item_content" v-else>
				<div class="input_item">
					<div class="input_name">兑换码：</div>
					<div class="input_box">
						<input type="text" />
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'fromInfo',
	props: ['data'],
	data() {
		return {
			form: {},
			lable: [],
		};
	},
	mounted() {
		var newLable = this.data.data;
		this.lable = [];
		newLable.map((e) => {
			this.lable.push(e.lable);
		});
	},
};
</script>

<style lang="scss" scoped>
@import '../../assets/css/curriculum.scss';
</style>